import { render, staticRenderFns } from "./theFooter.vue?vue&type=template&id=1a41251c&scoped=true"
import script from "./theFooter.vue?vue&type=script&lang=js"
export * from "./theFooter.vue?vue&type=script&lang=js"
import style0 from "./theFooter.vue?vue&type=style&index=0&id=1a41251c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41251c",
  null
  
)

export default component.exports